import { Form } from '@ant-design/compatible'

import ManageEquipmentForm from './ManageEquipmentForm'

export default Form.create({
  name: 'equipmentForm',
})(ManageEquipmentForm)
